import { render, staticRenderFns } from "./InstanceItemSkeleton.vue?vue&type=template&id=9bc1f7f0&scoped=true"
import script from "./InstanceItemSkeleton.vue?vue&type=script&lang=js"
export * from "./InstanceItemSkeleton.vue?vue&type=script&lang=js"
import style0 from "./InstanceItemSkeleton.vue?vue&type=style&index=0&id=9bc1f7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc1f7f0",
  null
  
)

export default component.exports